import React, { useEffect, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';

const ContactUs = () => {
    let login = JSON.parse(localStorage.getItem("login")) || "";
    const [data, setData] = useState({
        name: "",
        parent_name: "",
        email: "",
        phone: "",
        age: "",
        level: "",
        remark: "",
        student_id: login.emplyee_ID,
        mobile: login.full_name,
    })

    // const offices = [
    //     {
    //         id: 1,
    //         name: "Malad",
    //         address: "Malad, Upper Govind Nagar, Malad (E, Mumbai, Maharashtra 400097",
    //         type: "Corporate office",
    //         image: img1,
    //     },
    //     {
    //         id: 2,
    //         name: "Goregaon",
    //         address: "Rosary Church Campus, M.G. Road Cardinal Gracias Nagar, Goregaon West, Mumbai, Maharashtra 400104",
    //         type: "Center office",
    //         image:img1,
    //     },
    //     {
    //         id: 3,
    //         name: "Malad",
    //         address: "Kailash Puri, Plot No. 139, Malad, Upper Govind Nagar, Malad (E, Mumbai, Maharashtra 400097",
    //         type: "Center office",
    //         image: img1,
    //     },
    //     {
    //         id: 4,
    //         name: "Malad",
    //         address: "Kailash Puri, Plot No. 139, Malad, Upper Govind Nagar, Malad (E, Mumbai, Maharashtra 400097",
    //         type: "Center office",
    //         image: img1,
    //     },
    //     {
    //         id: 5,
    //         name: "Mumbai",
    //         address: "5th floor, Andheri East, Mumbai - 400059.",
    //         type: "Center office",
    //         image: img1,
    //     },
    //     {
    //         id: 6,
    //         name: "Mumbai",
    //         address: "Ground floor, Hitech City, Mumbai - 400081.",
    //         type: "Center office",
    //         image: img1,
    //     },
    // ];

    const [message, setMessage] = useState("");
    const [classname, setclassname] = useState([]);
    const [load, setLoad] = useState(false);
    const maxChars = 500;

    const handleMessageChange = (e) => {
        if (e.target.value.length <= maxChars) {
            setMessage(e.target.value);
        }
    };

    const handleChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
    }


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoad(true);
        try {
            const response = await fetch(`https://100billionoms.top/contact-us`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    name: data.name,
                    email: data.email,
                    // phone:data.phone,
                    age: data.age,
                    level: data.level,
                    parent_name: data.parent_name,
                    remark: message,
                    student_id: data.student_id,
                    mobile: data.mobile
                })
            })
            if (response.ok) {
                toast.success('Thank you for contacting!');
                setLoad(false);
            }
            setLoad(false);
        } catch (error) {
            console.log(error);
            setLoad(false);
        }

    }

    const fetchCenter = async () => {
        try {
            const response = await fetch(`https://100billionoms.top/classlevel/admin1997`)
            let res = await response.json();
            console.log(res);
            setclassname(res)
        } catch (error) {
            console.log(error)
        }
    }

    const activeClass = classname.filter(center_name => center_name.status === 'Active');

    const options2 = activeClass.map(language => ({
        value: language.class_level,
        label: (`${language.class_level}`),
    }));
    console.log(data, message);

    useEffect(() => {
        fetchCenter();
    }, [])

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
            <section className="contact-contact-us">
                <div className="contact-contact-header">
                    <h2>Get In Touch</h2>
                </div>
                <div className="contact-contact-content">
                    <div className="contact-contact-form">
                        <h3>Send us a Message</h3>
                        <form onSubmit={handleSubmit}>
                            <div className="contact-form-group">
                                <label><i className="fa-solid fa-user"></i> Name</label>
                                <input type="text" name='name' value={data.name} onChange={handleChange} placeholder="Enter your name" required />
                            </div>
                            <div className="contact-form-group">
                                <label><i className="fa-solid fa-envelope"></i> Email</label>
                                <input type="email" name='email' value={data.email} onChange={handleChange} placeholder="Enter your email" required />
                            </div>
                            <div className="contact-form-group">
                                <label><i className="fa-solid fa-phone"></i> Phone</label>
                                <input type="number" name='mobile' value={data.mobile} onChange={handleChange} placeholder="Enter your Phone" required />
                            </div>
                            {/* <div className="contact-form-group">
                                <label><i className="fa-solid fa-user"></i> Name</label>
                                <input type="text" name='name' value={data.name} onChange={handleChange} placeholder="Enter your name" required />
                            </div>
                            <div className="contact-form-group">
                                <label><i className="fa-solid fa-birthday-cake"></i> Age</label>
                                <input type="number" name='age' value={data.age} onChange={handleChange} placeholder="Enter your Age" required />
                            </div> */}

                            {/* <div className="contact-form-group">
                                <label><i className="fa-solid fa-signal"></i> Level</label>
                                <select id='school' name="level" value={data.level} onChange={handleChange} required>
                                    <option value="">Select Level</option>
                                    {options2.map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div> */}

                            <div className="contact-form-group">
                                <label><i className="fa-solid fa-message"></i> Message</label>
                                <textarea
                                    rows="4"
                                    placeholder="Your message"
                                    value={message}
                                    onChange={handleMessageChange}
                                ></textarea>
                                <p style={{ color: message.length === maxChars ? "red" : "black", textAlign: "right" }}>
                                    {message.length}/{maxChars} characters
                                </p>
                            </div>
                            {
                                load ? <button type="button" className="contact-submit-btn">
                                    <i className="fa-solid fa-paper-plane"></i> Sending...
                                </button> : <button type="submit" className="contact-submit-btn">
                                    <i className="fa-solid fa-paper-plane"></i> Send Message
                                </button>
                            }
                        </form>
                    </div>

                    <div className="contact-contact-info">
                        <h3>Contact Information</h3>
                        <p><i className="fa-solid fa-building"></i> HO. Agarwal Udyog Nagar, Sativali, Vasai East, 401208</p>
                        <p><i className="fa-solid fa-building"></i> Branch: Castle No.59/19, Sector-102, Dhankot, Gurugram(Hr) - 122505</p>
                        <p><i className="fa-solid fa-phone"></i> +91-2269711724</p>
                        <p><i className="fa-solid fa-envelope"></i> info@orabike.in<br />hr@orabike.in<br />nsm@orabike.in</p>
                        {/* <div className="contact-social-icons">
                            <i className="fa-brands fa-twitter"></i>
                            <i className="fa-brands fa-linkedin"></i>
                            <i className="fa-brands fa-instagram"></i>
                        </div> */}
                    </div>
                </div>
                <div className="contact-map-container">
                    <iframe
                        title="Our Location on Google Maps"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3763.0806021596763!2d72.85888659999999!3d19.408923100000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7a8d397f97079%3A0x8b7c934f66aa6066!2sAgarwal%20Udyog%20Nagar%2C%20Dewan%20And%20Shah%20Udyog%20Nagar%2C%20Golani%20Naka%2C%20Vasai%20East%2C%20Vasai-Virar%2C%20Maharashtra%20401208!5e0!3m2!1sen!2sin!4v1781348687356!5m2!1sen!2sin"
                        style={{ border: 0, width: '100%', height: '450px' }}
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                </div>
            </section>
            {/* <div>
                <div className="offices-section">
                    <h2>Our Offices</h2>
                    <div className="offices-container">
                        {offices.map((office) => (
                            <div key={office.id} className="office-card">
                                <div className="office-image">
                                    <img src={office.image} alt={office.name} />
                                    <span className="office-type">{office.type}</span>
                                </div>
                                <div className="office-info">
                                    <h3>{office.name}</h3>
                                    <p>
                                        <i className="fas fa-map-marker-alt"></i> {office.address}
                                    </p>
                                    <a href={`https://www.google.com/maps?q=${office.address}`} target="_blank" rel="noopener noreferrer" className="directions-btn">
                                        <i className="fas fa-external-link-alt"></i> View Directions
                                    </a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div> */}
        </>
    );
};

export default ContactUs;
